import Vue from 'vue'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import VeeValidate from 'vee-validate'
import FastClick from 'fastclick'
import 'normalize.css'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  Lazyload, Toast, CellGroup, Cell, Field, Popup, Picker, RadioGroup,
  Radio, Calendar, Area, Button, NoticeBar, Empty, Cascader, Pagination,
  Form, Switch, CheckboxGroup, Checkbox, Loading, List, Icon, NavBar,
  Skeleton, Badge, Stepper, Row, Col, Tabbar, TabbarItem, Search,
  Swipe, SwipeItem, SwipeCell, Tabs, Tab, TreeSelect, Dialog, PullRefresh,
  DropdownMenu, DropdownItem, Uploader
} from 'vant'
import { VeTable, VePagination, VeIcon, VeLoading } from 'vue-easytable'
import './assets/responsive'
import './assets/global.css'
import 'vant/lib/index.css'
import 'vue-easytable/libs/theme-default/index.css'
// import VConsole from 'vconsole'

if ('addEventListener' in document && 'ontouchstart' in window) {
  FastClick.prototype.focus = function (targetElement) {
    targetElement.focus()
  }
  document.addEventListener('DOMContentLoaded', function () {
    FastClick.attach(document.body)
  }, false)
}

Vue.config.productionTip = false
Vue.use(Vuex)

Vue.use(VueAxios, Axios)
Vue.use(VeeValidate)
// const vConsole = new VConsole()
// vConsole.setOption()

Vue.use(Lazyload)
// Vue.component(VueQrCode.name, VueQrCode)
Vue.component(Field.name, Field)
Vue.component(CellGroup.name, CellGroup)
Vue.component(Cell.name, Cell)
Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(Radio.name, Radio)
Vue.component(Calendar.name, Calendar)
Vue.component(Area.name, Area)
Vue.component(Button.name, Button)
Vue.component(NoticeBar.name, NoticeBar)
Vue.component(Empty.name, Empty)
Vue.component(Cascader.name, Cascader)
Vue.component(Pagination.name, Pagination)
Vue.component(Form.name, Form)
Vue.component(Switch.name, Switch)
Vue.component(CheckboxGroup.name, CheckboxGroup)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Loading.name, Loading)
Vue.component(List.name, List)
Vue.component(Icon.name, Icon)
Vue.component(NavBar.name, NavBar)
Vue.component(Skeleton.name, Skeleton)
Vue.component(Badge.name, Badge)
Vue.component(Stepper.name, Stepper)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.component(Tabbar.name, Tabbar)
Vue.component(TabbarItem.name, TabbarItem)
Vue.component(Search.name, Search)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.component(SwipeCell.name, SwipeCell)
Vue.component(Tabs.name, Tabs)
Vue.component(Tab.name, Tab)
Vue.component(TreeSelect.name, TreeSelect)
Vue.component(Dialog.Component.name, Dialog.Component)
Vue.component(PullRefresh.name, PullRefresh)
Vue.component(DropdownMenu.name, DropdownMenu)
Vue.component(DropdownItem.name, DropdownItem)
Vue.component(Uploader.name, Uploader)
Vue.use(VeTable)
Vue.use(VePagination)
Vue.use(VeIcon)
Vue.use(VeLoading)

Toast.setDefaultOptions({ duration: 3000 })
Vue.prototype.$toast = Toast

// http request 拦截器
// Axios.interceptors.request.use(
//     config => {
//         const currentInfo = loadCurrentInfo()
//         config.headers.Authorization = currentInfo.auth
//         Vue.$vux.mask.show()
//         return config
//     },
//     error => {
//         Vue.$vux.toast.show({
//             type: 'warning',
//             text: '请求异常，请稍后重试',
//             time: 3000
//         })
//         Vue.$vux.mask.hide()
//         return Promise.reject(error)
//     }
// )

// http response 拦截器
Axios.interceptors.response.use(
  response => {
    const code = Number(response.data.code)
    if (code !== 1000) {
      Toast({
        duration: 3000,
        message: response.data.message || '操作失败，请稍后重试'
      })
    }
    return response
  },
  error => {
    Toast({
      duration: 3000,
      message: '操作失败，请稍后重试'
    })
    return Promise.reject(error)
  }
)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
